
const setNews = (id) => {
    return {
        type: 'setID',
        id
    }
}

export default setNews